import {
  BooleanInput,
  Filter,
  ReferenceInput,
  SearchInput,
  SelectInput,
  usePermissions,
} from "react-admin";

import ProductionChainInput from "../research-projects/inputs/ProductionChainInput";
import ProgressInput from "./inputs/ProgressInput";
import React from "react";
import ResearchAreaInput from "../research-projects/inputs/ResearchAreaInput";
import { StateInput } from "ra-friendsofbabba";
import UserInput from "./inputs/UserInput";
import useView from "../research-projects/useView";

const Filters = (props) => {
  const isView = useView();
  const { loaded, permissions } = usePermissions();
  const isAdmin = loaded && permissions(["admin"]);
  return (
    <Filter {...props}>
      <SearchInput source="q" alwaysOn />
      {!isView && (
        <ReferenceInput
          source="company_type_entry_id"
          reference="company-type-entries"
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      )}
      {!isView && <StateInput source="state" alwaysOn />}

      <ResearchAreaInput
        label="ERC - L1"
        level={1}
        source="research_area_id_root"
        emptyText="ra.action.all"
        fullWidth
      />

      <ResearchAreaInput
        label="ERC - L2"
        level={2}
        source="research_area_id"
        dependency="research_area_id_root"
        emptyText="ra.action.all"
        fullWidth
      />

      <ProductionChainInput
        style={{ minWidth: 300 }}
        label={"resources.research-projects.fields.production_chain_id"}
        source="production_chain_id"
        emptyText="ra.action.all"
        fullWidth
      />

      <ProgressInput
        style={{ minWidth: 200 }}
        source="progress"
        fullWidth
        emptyText="ra.action.all"
      />
      <BooleanInput source="mine" defaultChecked defaultValue={true} />
      {isAdmin && <UserInput source="user_id" fullWidth />}
    </Filter>
  );
};
export default Filters;
